export const types = {
    SeoInfoBase: Symbol.for('ISeoInfoBase'),
    SeoFilterState: Symbol.for('ISeoFilterState'),
    SeoApplicationState: Symbol.for('IOrganisationSearchApplicationState'),
    SeoSortingState: Symbol.for('ISeoSortingState')
};
